import React from "react";
import "./Checkout.css";

function Checkout({ cartItems = [] }) {
  const total = cartItems.reduce(
    (sum, item) => sum + item.product.price * item.quantity,
    0
  );

  return (
    <div className="checkout-container">
      <div className="checkout-left">
        <h2>Contact Information</h2>
        <input type="email" placeholder="Email address" />

        <h2>Delivery</h2>
        <div className="checkout-row">
          <input type="text" placeholder="First name" />
          <input type="text" placeholder="Last name" />
        </div>
        <input type="text" placeholder="Address" />
        <input type="text" placeholder="Apartment, suite, etc. (optional)" />
        <div className="checkout-row">
          <input type="text" placeholder="City" />
          <input type="text" placeholder="State" />
          <input type="text" placeholder="ZIP code" />
        </div>
        <input type="text" placeholder="Phone (optional)" />

        <h2>Payment</h2>
        <p style={{ fontStyle: "italic", fontSize: "0.9rem" }}>
          (Payment integration coming soon...)
        </p>
      </div>

      <div className="checkout-right">
        <h2>Your Order</h2>
        {cartItems.length === 0 ? (
          <p>Your cart is empty.</p>
        ) : (
          cartItems.map((item, index) => (
            <div key={index} className="checkout-product">
              <img
                src={item.product.images[0]}
                alt={item.product.name}
              />
              <div>
                <p><strong>{item.product.name}</strong></p>
                <p>Size: {item.size}</p>
                <p>Quantity: {item.quantity}</p>
                <p>£{(item.product.price * item.quantity).toFixed(2)}</p>
              </div>
            </div>
          ))
        )}

        <div className="checkout-summary">
          <p><strong>Total:</strong> £{total.toFixed(2)}</p>
          <button className="pay-now">Pay Now</button>
        </div>
      </div>
    </div>
  );
}

export default Checkout;
